export default "__VITE_ASSET__DIA0NpAR__"